import { PROTOCOL_DISPLAY_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { ProtocolType, ProtocolTypeSummary } from '../../../types';
import { ChartColors } from '@silverfort/sf-components';

const PROTOCOL_TYPE_TO_COLOR: Record<ProtocolType, string> = {
    NTLM: ChartColors['data-bg-main-1'],
    Kerberos: ChartColors['data-bg-main-2'],
    LDAP: ChartColors['data-bg-main-3'],
    OIDC: ChartColors['data-bg-main-4'],
    SAML: ChartColors['data-bg-main-5'],
    API: ChartColors['data-bg-main-6'],
    Desktop: ChartColors['data-bg-main-7'],
    'AAD SSO': ChartColors['data-bg-main-8'],
    LDAPS: ChartColors['data-bg-main-9'],
    'Okta SSO': ChartColors['data-bg-main-10'],
    RADIUS: ChartColors['data-bg-main-11']
};

export const useProtocolTypeData = (
    onClick: (protocolType: ProtocolType) => void,
    protocolTypeSummary?: ProtocolTypeSummary[keyof ProtocolTypeSummary]
) => {
    const filteredSummary = Object.entries(protocolTypeSummary ?? {}).filter(([_, value]) => value > 0);

    return filteredSummary.map(([key, value]) => ({
        name: PROTOCOL_DISPLAY_NAMES[key.toUpperCase()],
        value,
        fill: PROTOCOL_TYPE_TO_COLOR[key],
        onClick: () => onClick(key as ProtocolType),
        tooltipContent: `${PROTOCOL_DISPLAY_NAMES[key.toUpperCase()]}: ${value}`,
        tooltipPlacement: 'top-start'
    }));
};
